import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TeamForm from '../../features/team-form/ui/TeamForm';
import { useFetchTeam } from './lib/useFetchTeam';

export default function TeamRewritePage() {
    const navigate = useNavigate();
    const { id: memberId } = useParams();

    const { member, isLoading, error, isCreateMode } = useFetchTeam(memberId);

    return (
        <>
            <section className="section-admin section-form">
                <div className="section-form__header">
                    <h2>{isCreateMode ? 'Додавання учасника' : 'Редагування учасника'}</h2>
                    <button onClick={() => navigate('/team')}>Повернутися</button>
                </div>

                <div className="section-form__content">
                    {isLoading && <p>Завантаження...</p>}
                    {error && <p className="error-text">{error}</p>}

                    {!isLoading && !error && (
                        <TeamForm
                            type={isCreateMode ? 'create' : memberId}
                            initialData={member}
                        />
                    )}
                </div>
            </section>

            <button form="team-create-form" className="product-form__submit" type="submit" disabled={isLoading}>
                {member ? 'Зберегти' : 'Додати'}
            </button>
        </>
    );
}
